import { Dialog } from '@angular/cdk/dialog';
import { ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AttachmentPreviewModalComponent,
  AttachmentPreviewModalData
} from './attachment-preview-modal/attachment-preview-modal.component';

/** Opens the full-screen attachment preview modal; emits once, when the modal closes. */
export function openAttachmentPreview(
  dialog: Dialog,
  data: AttachmentPreviewModalData,
  viewContainerRef?: ViewContainerRef
): Observable<void | undefined> {
  return dialog.open<void, AttachmentPreviewModalData, AttachmentPreviewModalComponent>(
    AttachmentPreviewModalComponent,
    {
      maxHeight: 'min(100%, 100svh)',
      maxWidth: 'min(100%, 100svw)',
      height: '100%',
      width: '100%',
      panelClass: 'attachment-preview-modal-panel',
      data,
      viewContainerRef
    }
  ).closed;
}
